/** i18n / browser may use `ar-EG` while API stores `ar`. */
export function baseLanguageCode(lang: string | undefined): string {
  return (lang || "en").split("-")[0] || "en";
}

/**
 * Map line/paragraph separators and legacy NEL to `\n` so `white-space: pre-line` always breaks.
 * Arabic editors and Word often emit U+2028 instead of LF.
 */
export function normalizeDisplayedLineBreaks(text: string): string {
  if (!text) return text;
  return text
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/\u2028/g, "\n")
    .replace(/\u2029/g, "\n")
    .replace(/\u0085/g, "\n");
}
